/* eslint-disable react/jsx-key */
// @flow
import React from 'react';
import { Route } from 'react-router-dom';
import { translate } from 'react-i18next';
import withRouteTracker from 'common/middleware/RouteTracker';

import { Title } from 'common/components/common';

import ClientConfigService from 'common/services/ClientConfigService';
import { EntityMgmtHeader } from 'common/containers/AppHeaderContainer';

import { MySettingsContainer } from 'platform/mysettings';

import Products from 'common/enums/Product';

import SectionWrap from 'common/components/common/SectionWrap';
import { lazy } from 'common/modules/mfe';

import { type GetRoutesFn } from './types';

const InsightsRoutes = lazy(() =>
    import('platform-app/analytics/InsightsRoutes')
);
const TrackedInsightsRoutes = withRouteTracker(
    InsightsRoutes,
    Products.PLATFORM
);

const MetricsRoutes = lazy(() =>
    import('platform-app/analytics/MetricsRoutes')
);
const TrackedMetricsRoutes = withRouteTracker(MetricsRoutes, Products.PLATFORM);

const AlertsContainer = lazy(() =>
    import('platform-app/alerts/AlertsContainer')
);
const TrackedAlertNotificationContainer = withRouteTracker(
    translate()(() => {
        return (
            <SectionWrap>
                <Title i18nKey="alertNotifications" />
                <AlertsContainer />
            </SectionWrap>
        );
    }),
    Products.PLATFORM
);

const ReportsContainer = lazy(() =>
    import('platform-app/reports/ReportsContainer')
);
const TrackedReportsContainer = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="customReports" />
                <EntityMgmtHeader {...props} />
                <ReportsContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.PLATFORM
);

const TrackedMySettingsContainer = withRouteTracker(
    translate('settings')(({ ...rest }) => {
        return (
            <SectionWrap>
                <Title i18nKey="mySettings" />
                <EntityMgmtHeader {...rest} />
                <MySettingsContainer {...rest} />
            </SectionWrap>
        );
    }),
    Products.PLATFORM
);

const getRoutes: GetRoutesFn = ({ match, visibleSections, alertsSettings }) => {
    return [
        <Route
            exact
            path={`${match.path}/mysettings`}
            component={TrackedMySettingsContainer}
        />,

        // Analytics Routes
        ...(visibleSections.showInsightsSection
            ? [
                  <Route
                      path={`${match.path}/metrics`}
                      component={TrackedMetricsRoutes}
                  />,

                  <Route
                      path={`${match.path}/insights`}
                      component={TrackedInsightsRoutes}
                  />
              ]
            : []),

        <Route
            path={`${match.path}/reports/:reportId?`}
            component={TrackedReportsContainer}
        />,
        ClientConfigService.isAlertsEnabled() &&
            alertsSettings?.isAlertsEnabled && (
                <Route
                    exact
                    path={`${match.path}/notification/:podId/:streamName`}
                    component={TrackedAlertNotificationContainer}
                />
            )
    ].filter(Boolean);
};

export default getRoutes;
